import React, { useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";

export const DangerZoneCard = () => {
  const [busy, setBusy] = useState(false);
  const [confirm, setConfirm] = useState(false);

  const purgeLegacy = async () => {
    setBusy(true);
    try {
      const r = await api.delete("/wallet/purge-legacy");
      const total = (r.data?.wallet_entries_deleted || 0) + (r.data?.platform_revenue_deleted || 0);
      toast.success(
        total > 0
          ? `Removed ${total} legacy revenue ${total === 1 ? "row" : "rows"}.`
          : "No legacy data found — you're already clean."
      );
      setConfirm(false);
    } catch {
      toast.error("Couldn't purge legacy data. Try again in a moment.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border border-red-900/40 bg-red-950/10 p-6" data-testid="danger-zone-card">
      <div className="text-[10px] uppercase tracking-[0.22em] text-red-400/80 mb-3">Danger zone</div>
      <div className="text-sm text-zinc-200 mb-1">Purge legacy revenue data</div>
      <p className="text-[11px] text-zinc-500 leading-relaxed mb-4">
        Removes seeded platform revenue rows from your wallet history left over
        from earlier previews. Real invoice payments and payouts are never
        touched. This can't be undone.
      </p>
      {!confirm ? (
        <button
          onClick={() => setConfirm(true)}
          disabled={busy}
          data-testid="open-purge-legacy-btn"
          className="border border-red-900/60 hover:border-red-500 text-red-300 hover:text-red-200 text-sm px-4 py-2 rounded-md inline-flex items-center gap-2 disabled:opacity-50"
        >
          <Trash2 size={14} />
          Purge legacy data
        </button>
      ) : (
        <div className="flex flex-wrap items-center gap-3" data-testid="purge-legacy-confirm">
          <span className="text-[11px] text-red-300">
            Are you sure? This deletes all simulated platform revenue.
          </span>
          <button
            onClick={purgeLegacy}
            disabled={busy}
            data-testid="confirm-purge-legacy-btn"
            className="bg-red-600 hover:bg-red-500 text-white text-sm px-4 py-2 rounded-md inline-flex items-center gap-2 disabled:opacity-60"
          >
            {busy && <Loader2 size={14} className="animate-spin" />}
            Yes, delete
          </button>
          <button
            onClick={() => setConfirm(false)}
            disabled={busy}
            data-testid="cancel-purge-legacy-btn"
            className="text-sm px-3 py-2 rounded-md text-zinc-400 hover:text-white"
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};
